module.exports = __webpack_public_path__ + "static/img/7.605f10a1.jpg";